import React, { useEffect, useRef, useState } from 'react';
//import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { FileUpload } from 'primereact/fileupload';
import FileService from '../service/FileService';
import CustomArtLabel from './CustomArtLabel';
import Constants from '../constants/Constants';
import { useNavigate } from 'react-router-dom';

const CarouselItemTemplate = (props) => {
    const navigate = useNavigate();

    console.log("CarouselItemTemplate", props);

    let fileUploadRef = useRef();

    const ref = useRef(null);
    const [showCount, setShowCount] = useState(null);


    const chooseOptions = { icon: 'fas fa-pen-to-square', iconOnly: true, className: 'p-button-rounded p-button-header file-upload ' };


    
    const onSelectedExhibit=(param)=>{
        console.log("onSelectedExhibit",param)
        navigate("/exhibition/view/" + param.id );
    }


    const carouselItemTemplate = (exhibition, isLast) => {
        //  console.log("carouselItemTemplate", exhibition, isLast);
        return (
            <div 
            className='pointer'
            style={{
                display: 'flex',
                justifyContent: 'center',
                margin: 10,
                backgroundImage: `url(${FileService.inquireFilePath(exhibition?.headerCoverPath ? exhibition?.headerCoverPath : exhibition?.headerimageData?.file)})`,
                backgroundRepeat: 'no-repeat',
                borderRadius: 20,
                backgroundSize: 'cover',
                backgroundPositionX: 'center',
                backgroundPositionY: 'center',


            }}

                onClick={
                    () => {
                        //  props.onAction(0);
                    !props.isEdit &&    
                        onSelectedExhibit(exhibition);

                    }
                }

            >
                <div style={{

                    width: '100%',

                }}>

                    <div style={{

                        flexDirection: 'column', // inner items will be added vertically
                        flexGrow: 1,            // all the available vertical space will be occupied by it
                        justifyContent: 'space-between', // will create the gutter between body and footer
                        height: '100%',
                        minHeight: 400,
                        display: 'flex',
                        background: 'linear-gradient(rgb(0,0,0,0), rgb(0, 0,0,0.7))',
                        borderRadius: 20,
                        padding: 10,

                    }}>


                        <CustomArtLabel image={exhibition.profileImage} label={exhibition.userType == Constants.userType.company ? exhibition.companyName : exhibition.firstName + " " + exhibition.lastName} />


                        <div style={{

                            color: '#ffffff',
                            textAlign: 'center',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            flexDirection: 'column', // inner items will be added vertically
                            flexGrow: 1,            // all the available vertical space will be occupied by it


                        }}>
                            {
                                props.isEdit && <div style={{
                                    height: '60%',
                                    paddingTop: '50%',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'row', // inner items will be added vertically

                                }}>

                                    <Button icon="fas fa-trash" className={"p-button-rounded p-button-header mr-2"} onClick={() => props.onDeleteFile()} />
                                    <Button icon="fas fa-cloud-arrow-up" className={"p-button-rounded p-button-header mr-2"} onClick={() => props.onUploadFile(props.exhibition)} />



                                </div>
                            }
                            <div style={{
                                height: '40%',
                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'column', // inner items will be added vertically

                            }}>

                                <div className="question" style={{
                                    fontSize: 24,
                                    color: '#ffffff',
                                    padding: 10,

                                    textAlign: 'center',

                                }} >
                                    {exhibition.exhibitionName}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    };


    return (
        <div ref={ref}>
            <div style={{ background: 'linear-gradient(rgb(0,0,0,0), rgb(0, 0,0,0.7))', }}></div>
            {carouselItemTemplate(props.exhibition, props.isLast)}
        </div>
    );
};

export default CarouselItemTemplate;
